const DAYS_PER_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const formatDateInput = (value: string) => {
    const digits = value.replace(/\D/g, '');

    const len = digits.length;
    let formattedValue = '';

    if (len === 0) {
        formattedValue = '';
    } else if (len <= 2) {
        formattedValue = digits;
    } else if (len <= 4) {
        formattedValue = `${digits.slice(0, 2)}.${digits.slice(2)}`;
    } else {
        formattedValue = `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4, 8)}`;
    }

    return formattedValue;
};

// Input has to be of format: ddMMyyyy, where input is a string of numbers
export const isValidDate = (date: string): boolean => {
    const day = Number(date.substring(0, 2));
    const month = Number(date.substring(2, 4));
    const year = Number(date.substring(4));
    const isExtraDay = (year % 4 === 0) && (month === 2);

    if (month > 12 || month < 1) {
        return false;
    }

    const maxDaysInMonth = DAYS_PER_MONTH[month - 1] + (isExtraDay ? 1 : 0);

    return !(day < 1 || day > maxDaysInMonth);
}

// Input has to be of format: ddMMyyyy, where input is a string of numbers
export const isInFuture = (date: string) => {
    const day = Number(date.substring(0, 2));
    const month = Number(date.substring(2, 4));
    const year = Number(date.substring(4));

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate. getDate();

    if (year > currentYear) {
        return true;
    } else if (year === currentYear) {
        if (month > currentMonth) {
            return true;
        } else if (month === currentMonth) {
            if (day > currentDay) {
                return true;
            }
        }
    }

    return false;
}

// Input has to be of format: ddMMyyyy, where input is a string of numbers
export const isInPast = (date: string) => {
    const day = Number(date.substring(0, 2));
    const month = Number(date.substring(2, 4));
    const year = Number(date.substring(4));

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();

    if (year < currentYear) {
        return true;
    } else if (year === currentYear) {
        if (month < currentMonth) {
            return true;
        } else if (month === currentMonth) {
            if (day < currentDay) {
                return true;
            }
        }
    }

    return false;
};

// Input has to be of format: ddMMyyyy, where input is a string of numbers
export const isOutsideYearRange = (date: string, minYear: number = 0, maxYear: number = 9999) => {
    const year = Number(date.substring(4));
    const currentYear = new Date().getFullYear();

   return year > currentYear + maxYear || year < currentYear - minYear;
}
